import { render, staticRenderFns } from "./EntityCases.vue?vue&type=template&id=71edb359&scoped=true&"
import script from "./EntityCases.vue?vue&type=script&lang=js&"
export * from "./EntityCases.vue?vue&type=script&lang=js&"
import style0 from "./EntityCases.vue?vue&type=style&index=0&id=71edb359&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edb359",
  null
  
)

export default component.exports